import React from 'react'
import { withIcon } from '../../withIcon'

function PlusIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 4.875C12.3452 4.875 12.625 5.15482 12.625 5.5V11.875H19C19.3452 11.875 19.625 12.1548 19.625 12.5C19.625 12.8452 19.3452 13.125 19 13.125H12.625V19.5C12.625 19.8452 12.3452 20.125 12 20.125C11.6548 20.125 11.375 19.8452 11.375 19.5V13.125H5C4.65482 13.125 4.375 12.8452 4.375 12.5C4.375 12.1548 4.65482 11.875 5 11.875H11.375V5.5C11.375 5.15482 11.6548 4.875 12 4.875Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PlusIcon)
